import React, { useEffect, useState } from 'react';
import { Button, cn, Heading, IconButton, Typography } from '@kiiwi/ui';
import Cookies from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { IS_XS, useMediaQueryBreakPoint } from '@/src/hooks';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { useTranslation } from '@/src/i18n';
import { PATIENT_APP_ANDROID_URL, PATIENT_APP_IOS_URL } from '@/src/constants';
import { isIOS, isProductionEnvironment } from '@/src/utils';

const cookieKey = 'dowloadAppBannerDismissed';

const DownloadAppBanner = () => {
  const { t } = useTranslation();

  const [displayed, setDisplayed] = useState(Cookies.get(cookieKey) !== 'true');

  const isFromBanner = useSearchParams().get('isFromBanner');
  const isPhone = useMediaQueryBreakPoint(IS_XS);
  const isIOSDevice = isIOS();
  const isProduction = isProductionEnvironment();

  const onClose = () => {
    Cookies.set(cookieKey, 'true', { expires: 7 });
    setDisplayed(false);
  };

  useEffect(() => {
    if (isFromBanner) {
      window.location.href = isIOSDevice
        ? PATIENT_APP_IOS_URL
        : PATIENT_APP_ANDROID_URL;
    }
  }, [isFromBanner, isIOS]);

  if (!isPhone || !displayed) return null;
  return (
    <div className="flex flex-row items-center bg-surface-white px-2 py-3">
      <IconButton size="sm" className="size-6 [&_svg]:size-3" onClick={onClose}>
        <FontAwesomeIcon name="xmark:regular" />
      </IconButton>
      <div className="flex flex-auto flex-row items-center gap-2">
        <img src="/logo.png" alt="" className="size-10" />
        <div className="flex flex-col overflow-hidden">
          <Heading
            as="h3"
            variant="subtitle-3"
            className="truncate leading-5 text-neutral-primary"
          >
            {t('download_app_banner_title')}
          </Heading>
          <Typography variant="body-3" className="truncate">
            {t('download_app_banner_description')}
          </Typography>
        </div>
        <Button
          size="sm"
          className={cn(
            'ml-auto',
            isIOSDevice ? 'bg-[#0073e5] uppercase' : 'bg-[#2b855d]',
          )}
          asChild
        >
          <a
            href={`${
              isProduction
                ? 'https://www.maiia.com'
                : 'https://www.staging.maiia.com'
            }?isFromBanner=true`}
          >
            {t('download_app_banner_cta')}
          </a>
        </Button>
      </div>
    </div>
  );
};

export { DownloadAppBanner };
